import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { isTrueMobileDevice } from '../utils/device-detection.util';

/**
 * Guard de route qui redirige les vrais appareils mobiles (téléphones) vers /mobile-blocked.
 * Détection basée sur le User-Agent uniquement (pas la taille d'écran).
 * Les tablettes et desktops passent normalement.
 */
export const mobileDeviceGuard: CanActivateFn = () => {
  if (isTrueMobileDevice()) {
    inject(Router).navigate(['/mobile-blocked']);
    return false;
  }
  return true;
};
